import styled from 'styled-components';

const ModalContent = styled.form`
    display: grid;
    gap: 1.5rem;
`;

export default ModalContent;